// extracted by mini-css-extract-plugin
module.exports = {"collapseCard":"styles_collapseCard__1eyGr","arrow":"styles_arrow__gVkb3","body":"styles_body__2DnaT","title":"styles_title__328CD"};